module.exports = __webpack_public_path__ + "static/media/Activos.dd6e1c5e.svg";